import { getEnvironment } from 'utils/buildUrls';
import { getLocationOrigin } from 'utils/utils';
import umbrella from '@nackle/umbrella';

const ENV = getEnvironment() || 'prod';
const isProd = ENV === 'prod';
const envPrefix = isProd ? '' : `${ ENV }.`;
const KONG_URL = `https://${ envPrefix }api.biw.cloud`;

const CONFIG = {
    ENV,
    // eslint-disable-next-line no-undef
    COMPANY_CODE: COMPANY_CODE || getLocationOrigin(),
    API_URL: KONG_URL,
    PROVIDER_URL: `${ KONG_URL }/v1/id`,
};

export const auth = umbrella.getAuth( true, 60, 59,
     { authority: CONFIG.PROVIDER_URL,  
       extraQueryParams: { source: window.location.href }
        } );

export default CONFIG;
